import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { PipesModule } from "../../../../shared/_pipes/pipes.module";
import { DirectivesModule } from "../../../directives/directives.module";
import { AdministrativeCentersComponent } from "./administrative-centers.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        PipesModule,
        DirectivesModule,
        DropDownListModule
    ],
    declarations: [
        AdministrativeCentersComponent
    ],
    exports: [
        AdministrativeCentersComponent
    ]
})
export class AdministrativeCentersModule { }
